<!-- <table style="margin-left: 2vw; margin-top: 1vw; width:85%">
  <tr>
    <th style="margin: auto; text-align: center; width: 25%" ><b>Nombre</b></th>
    <th style="margin: auto; text-align: center;"><b>Descripción</b></th>
    <th style="margin: auto; text-align: center;"><b>uuid</b></th>
    <th style="margin: auto; text-align: center; width: 5%"><b>Dispositivos en la estructura</b></th>
    <th style="margin: auto; text-align: center; width: 5%"><b>Cantidad de datos</b></th>
    <th style="margin: auto; text-align: center;"><b>Acción</b></th>
  </tr>
  <tr *ngFor="let factory of dispRaiz | paginate: { itemsPerPage: 10, currentPage: p }">
    <td style="margin: auto; text-align: center; " *ngIf="factory.estructuraCantidad!=0; else elseBlock"> {{factory.nombre}} </td>
    <ng-template #elseBlock>
      <td style="margin:auto; text-align:center;" *ngIf="factory.tiene.length===0; else elseBlock2">
       {{ factory.nombre }} 
        <span style="float:right; padding-inline-end: 10px">
         <i class="material-icons" style="color:rgb(80, 194, 90); cursor: help;" 
           title="Detectado dispositivo de un posible arbol de estructura nuevo"> fiber_new 
         </i>
        </span>
      </td>
    </ng-template>
    <ng-template #elseBlock2>
      <td style="text-align:center;" *ngIf="factory.tiene.length!=0; else elseBlock2">
       {{ factory.nombre }} 
        <span style="float:right; padding-inline-end: 10px">
         <i class="material-icons" style="color:rgb(255, 77, 77); cursor: help;" 
           title="El dispositivo no tiene ningún otro dispositivo en su estructura"> warning 
         </i>
        </span>
      </td>
    </ng-template>
    <td style="margin: auto; text-align: center;"> {{factory.descripcion}} </td>
    <td style="margin: auto; text-align: center;"> {{factory.uuid}} </td>
    <td style="margin: auto; text-align: center;"> {{factory.estructuraCantidad}} </td>
    <td style="margin: auto; text-align: center;"> {{factory.tiene.length}} </td>
    <td>
      <button style="display: block; margin: auto;" class="btn btn-secondary" id="iraldispositivo"
        [routerLink]="['/disp', factory.uuid]">
        Ir al dispositivo
      </button>
    </td>
  </tr>

</table>

<div align="center" style="width:85%">
  <pagination-controls (pageChange)="p = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
</div>
 -->

<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Buscar en la tabla..."
  />
</mat-form-field>

<div align="center" style="width: 85%" [hidden]="!loading">
  <mat-progress-spinner
    mode="indeterminate"
    strokeWidth="3"
    value="7"
    diameter="75"
    style="margin: 0 auto"
  ></mat-progress-spinner>
</div>

<div
  class="mat-elevation-z8"
  style="width: 85%"
  align="center"
  [hidden]="loading"
>
  <!--   -->
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef><b>Nombre</b></th>
      <td mat-cell *matCellDef="let factory">
        <span *ngIf="factory.estructuraCantidad != 0">{{
          factory.nombre
        }}</span>
        <span
          *ngIf="factory.estructuraCantidad === 0 && factory.tiene.length === 0"
          >{{ factory.nombre }}
          <i
            class="material-icons"
            style="color: rgb(80, 194, 90); cursor: help"
            title="Detectado dispositivo de un posible arbol de estructura nuevo"
          >
            fiber_new
          </i>
        </span>
        <span
          *ngIf="factory.estructuraCantidad === 0 && factory.tiene.length != 0"
          >{{ factory.nombre }}
          <i
            class="material-icons"
            style="color: rgb(255, 77, 77); cursor: help"
            title="El dispositivo no tiene ningún otro dispositivo en su estructura"
          >
            warning
          </i>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef><b>Descripcion </b></th>
      <td mat-cell *matCellDef="let factory">{{ factory.descripcion }}</td>
    </ng-container>

    <ng-container matColumnDef="uuid">
      <th mat-header-cell *matHeaderCellDef><b>uuid</b></th>
      <td mat-cell *matCellDef="let factory">
        <span
          ngxClipboard
          [cbContent]="factory.uuid"
          (cbOnSuccess)="copiado($event)"
          >{{ factory.uuid }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="cantidadDatos">
      <th mat-header-cell *matHeaderCellDef>
        <b> Dispositivos en la estructura </b>
      </th>
      <td mat-cell *matCellDef="let factory">
        {{ factory.estructuraCantidad }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dispEnEstructura">
      <th mat-header-cell *matHeaderCellDef><b> Datos en la estructura </b></th>
      <td mat-cell *matCellDef="let factory">{{ factory.tiene.length }}</td>
    </ng-container>

    <ng-container matColumnDef="botones">
      <th mat-header-cell *matHeaderCellDef><b>Acción</b></th>
      <td mat-cell *matCellDef="let factory" align="center">
        <a
          [routerLink]="['/disp', factory.uuid]"
          title="Navegar al dispositivo {{ factory.nombre }}"
        >
          <i
            class="material-icons"
            id="navegar-dispositivo"
            style="color: #303f9f; cursor: pointer"
          >
            forward
          </i>
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[10, 20, 100]"
    showFirstLastButtons
    [hidden]="loading"
  ></mat-paginator>
</div>

<!-- Boton para añadir un nuevo registro -->
<!-- <div class="addDispRaiz"[hidden]="loading" >
    <a style="cursor: pointer;" title="Añadir un nuevo dispositivo raiz">
        <i class="material-icons" style="color:rgb(80, 194, 90); font-size: 45px;">
            add_circle
        </i>
    </a>
</div>
 -->
